/* src/app/navigation/components/sem-breadcrumbs/sem-breadcrumbs.component.css */
/*# sourceMappingURL=sem-breadcrumbs.component.css.map */
